module.exports = __webpack_public_path__ + "f7a71e6fe7c8884a751642e682b51853.png";